import type { FaireProductEntity } from "../../entity_types/product";

export const p_pv9yhxtz9k: FaireProductEntity = {
  token: "p_pv9yhxtz9k",
  type: "product",
  name: "Crumbs: Cookies And Sweets From Around The World (2024)",
  brandToken: "b_daarv8jc3a",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/7fdd07e63595a5f56eb50125f6cc2dc443dd72daed18e3f48d6e0a6c6cb276f4.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/93c7e1c34ffb5d4ff764be8817248279bd76d1ea0e4fecb6e72aa5d7c8d1c3f0.webp",
    "https://cdn.faire.com/fastly/fd148acef4f5ac0fcf92735d55949f2fa8cbf943fccd2051dc88fb58677b2f06.webp",
    "https://cdn.faire.com/fastly/fe077a1bfb07893d725fb496bc03781c85b432692b65cb12de96998390209cc3.webp",
    "https://cdn.faire.com/fastly/6feeca96c71d624fe955382a7e07e992e1ed48abec6fd710bd650a5e10346a48.webp",
    "https://cdn.faire.com/fastly/6a8e1d3f1465cf05b2bb4caecb94eef43f63789228aefff51842a3022d4154a1.webp",
    "https://cdn.faire.com/fastly/971590d830e0a9e249f903a025560e90d76b3db6ebdd2268efe112c28bbbe13a.webp",
    "https://cdn.faire.com/fastly/93e0f21d2a448992db61e5b0e340bb7d2bb1feefc77bf74d6e55b6667f5023f0.webp",
    "https://cdn.faire.com/fastly/b65cc300b1816152b0b1cd19c24b1df1f8bfa97f536f2a39c102c42de279402b.webp",
    "https://cdn.faire.com/fastly/036d466bec30bed884ac759b633b19f6feb0fb8caf82955da5f5e9e25e89c7df.webp",
    "https://cdn.faire.com/fastly/61d0c7625e1e6f779ffdb6a2c6d3b8875851c1df18290a43290784d344614780.webp",
  ],
  priceDollars: 24.98,
  description:
    "Named one of the best cookbooks of 2024 by the new york times, los angeles times, washington post, forbes, bustle, food & wine, eater, food network, the national post\n\n‘There is sweetness to be had on every page of Crumbs, and so many delicious discoveries, too.’ – Dorie Greenspan, New York Times bestselling author\n\n‘As one of our most gifted writers and bakers, Mims invites you to explore the rich diversity of cookies in Crumbs sparking your curiosity - and cravings - with every page.’ – Andy Baraghani, New York Times bestselling and James Beard Award-winning author\n\nBake your way around the world with the ultimate collection of 300 irresistible, authentic, and delicious cookie recipes from nearly 100 countries\n\nWhether enjoyed at breakfast, with afternoon tea, on holidays or as a late-night snack, cookies are a universally beloved treat. In Crumbs, food writer, recipe developer, and self-confessed baking obsessive Ben Mims takes home cooks on a delicious tour across countries.",
  tags: [],
  msrpDollars: 49.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:32.545Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
